import { __assign } from "tslib";
import { ContextualMenu, FontIcon, } from '@fluentui/react';
import { getFileTypeIconProps } from '@uifabric/file-type-icons';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './ContextMenuControl.module.scss';
export var ContextMenuControl = function (_a) {
    var menu = _a.menu, hidden = _a.hidden, target = _a.target, mouseEvent = _a.mouseEvent, onItemClick = _a.onItemClick, onDismiss = _a.onDismiss;
    var targetProp = mouseEvent !== null && mouseEvent !== void 0 ? mouseEvent : target;
    var contextualMenuItemStyle = useMemo(function () { return ({
        root: classNames(styles['context-menu-item'], 'ms-bgc-g40-h ms-bgc-w ms-bgc-g40-f ms-bgc-g40-a'),
        item: styles['menu-item__flex-content'],
        label: classNames(styles['context-menu-item__title'], 'ms-fcl-bl'),
        subMenuIcon: styles['submenu-icon'],
    }); }, []);
    var getMenuItems = function (items) {
        var menuItems = items.map(function (item) {
            var menuItem = {
                key: item.id,
                text: item.title,
                disabled: item.disabled,
                onClick: function (event) {
                    if (item.executeAction) {
                        item.executeAction(event);
                    }
                },
            };
            menuItem.itemProps = {
                item: menuItem,
                className: 'context-menu-item',
                styles: contextualMenuItemStyle,
            };
            if (item.extension) {
                var renderIconFunction = function () {
                    return (React.createElement(FontIcon, __assign({ className: styles['menu-icon'] }, getFileTypeIconProps({
                        size: 16,
                        extension: item.extension,
                        imageFileType: 'svg',
                    }))));
                };
                menuItem.onRenderIcon = renderIconFunction;
            }
            if (item.icon) {
                menuItem.iconProps = {
                    iconName: item.icon,
                    className: classNames(styles['context-menu__icon'], 'ms-fcl-bl'),
                };
            }
            if (item.renderIcon) {
                menuItem.onRenderIcon = item.renderIcon;
            }
            if (item.subMenus) {
                menuItem.subMenuProps = {
                    items: getMenuItems(item.subMenus),
                };
            }
            return menuItem;
        });
        return menuItems;
    };
    var menuItems = getMenuItems(menu.items);
    return (React.createElement(ContextualMenu, { items: menuItems, hidden: hidden, target: targetProp, onItemClick: onItemClick, onDismiss: onDismiss, className: classNames(styles['context-menu'], 'ms-bgc-w') }));
};
//# sourceMappingURL=ContextMenuControl.js.map